class Product {
  constructor(currentConfiguration, base, wingLeft, wingMiddle, wingRight, handle) {
    this.currentConfiguration = currentConfiguration;
    this.base = base;
    this.wingLeft = wingLeft ?? { top: null, left: null, right: null, middle:null, bottom: null };
    this.wingRight = wingRight ?? { top: null, left:null, right: null, middle:null, bottom: null };
    this.handle = handle;
  }

  setCustom(op) {
    this.currentConfiguration = op;
  }

  setColor(color) {
    const frame = this.base.children[0];
    frame.material.color.setHex(color);
  }
}

export default Product;